import { withChartLayout } from 'components/common';
import DeliveryRoomSummary from 'components/features/chart/admission-history/delivery-room-summary/DeliveryRoomSummary';

const DeliveryRoomSummaryPage = withChartLayout('Delivery Room Summary')(DeliveryRoomSummary);
export default DeliveryRoomSummaryPage;
